import * as React from 'react';
import './ToolTip.css';

export interface ToolTipProps {
  titleClasses?: string;
  tooltip: string;
}
export const ToolTipText: React.FC<any> = ({
  children,
  titleClasses,
  tooltip,
}) => {
  return (
    <p className={`tooltip ${titleClasses ? titleClasses : ''}`}>
      {children}
      <span className="tooltip-text id-bg-gray-700 id-text-white id-text-xs id-font-thin id--mt-6 id--ml-6 id-rounded ">
        {tooltip}
      </span>
    </p>
  );
};
